"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _totalPrice = _interopRequireDefault(require("../totalPrice"));
var countCatalogPrice = function countCatalogPrice(price) {
  var percent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.2;
  return (0, _totalPrice["default"])(price / percent, 1);
};
var _default = countCatalogPrice;
exports["default"] = _default;